var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"public-imgtext-page"},[(_vm.$route.query.menutype == 2)?_c('textImgContent'):_c('questionList',{staticStyle:{"padding-top":"0"},attrs:{"position":"right"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }